import { formatClock, formatElapsed } from '../lib/format'
import { useTick } from './useTick'
import type { Block, Category } from '../data/types'

interface Props {
  block: Block
  category: Category | undefined
}

/**
 * What is recording, and for how long, on a page that is not Now.
 *
 * It keeps its own clock, so a second ticking over redraws this and not the
 * timeline behind it.
 */
export function RecordingPill({ block, category }: Props) {
  const now = useTick()
  return (
    <span
      title={`Recording ${category?.label ?? 'something'} since ${formatClock(new Date(block.start))}`}
      style={{ '--c': category?.color ?? 'var(--tg-accent)' } as React.CSSProperties}
      className="flex shrink-0 items-center gap-2 rounded-lg border border-[color-mix(in_oklab,var(--c)_40%,transparent)] bg-[color-mix(in_oklab,var(--c)_12%,var(--tg-surface))] px-2.5 py-1"
    >
      <span className="relative flex size-2 shrink-0" aria-hidden="true">
        <span className="absolute inline-flex size-full rounded-full bg-[var(--c)] opacity-70 motion-safe:animate-ping" />
        <span className="relative inline-flex size-2 rounded-full bg-[var(--c)]" />
      </span>
      <span className="text-[13px] leading-none font-medium text-[color-mix(in_oklab,var(--c)_72%,var(--tg-text))]">
        {category?.shortLabel ?? 'recording'}
      </span>
      <span className="text-[13px] leading-none text-dim tnum">
        {formatElapsed(now - block.start)}
      </span>
    </span>
  )
}
